import axios from '@/lib/axios'
import store from '@/store'

export function getAgencies(filter = {}) {
  let params = { ...filter }
  const userLevel = store.state.account.userLevel
  if (userLevel === 'agency_admin')
    params.ids = store.state.account.agencies.join(',')
  if (userLevel === 'state_admin' || userLevel === 'naddi_admin')
    params.state = store.state.account.states.join(',')
  return axios().get('/api/misc/agencies', { params })
}
